export class MappingFilter {
    oldProvider: string;
    oldVersion: string;
    oldCondition: string;
    newProvider: string;
    newVersion: string;
    newCondition: string;
}



// WEBPACK FOOTER //
// ./src/app/admin/importclient/mapping-filter.model.ts